/**
 * Canonical public booking URLs, always on https://invitey.ca. Used for share
 * links and QR codes so a printed code never points at a dev/preview origin.
 * Custom hostnames are managed on the Custom domains tab and aren't the
 * primary share link.
 */
export function bookingUrl(orgSlug: string, path = ''): string {
  return `https://invitey.ca/${orgSlug}${path}`;
}
